module.exports = __webpack_public_path__ + "static/img/hotel-placeholder.609f3a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/hotel-placeholder.svg
// module id = TPhj
// module chunks = 0